// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { modalButtonsActionStyles } from "@awc/XDL/Utilities";
import { addTagsModalStyles } from "@insite/content-library/Widgets/MyListsDetails/AddTagsModal";
import { css } from "styled-components";

addTagsModalStyles.buttonsGridItem = modalButtonsActionStyles.buttonsGridItem;

addTagsModalStyles.cancelButton = modalButtonsActionStyles.cancelButton;

addTagsModalStyles.saveButton = modalButtonsActionStyles.submitButton;

addTagsModalStyles.tagsInstructionGridItem = {
    width: 12,
    css: css`
        padding: 5px 15px 0 15px;
    `,
};

addTagsModalStyles.tagInputText = {};

addTagsModalStyles.fakeTextFieldStyle = {
    css: css`
        border: none;
        padding: 0;
        margin-top: 0;
    `,
};
